/**
 * 菜单页
 */
import React, { FC, useEffect, useState, createContext, useRef, useMemo, useCallback } from 'react'
import { observer } from 'mobx-react'
import { IonPage, IonContent, useIonViewDidEnter } from '@ionic/react'
import { restaurantConfig, restaurantCenter, storeMobx, cartMobx, orderMobx, discountMobx, productMobx } from 'restaurant'
import { TEEatType } from 'restaurant/mobx/store.mobx'
import { decorationMobx, deliveryMobx, memberMobx, advertMobx, multiPersonMobx, eatTypeStatusMobx, timePickMobx, preOrderingMobx, multiPersonOrderingMobx, themeMobx } from '@mobxStore'
import { useHistoryNew, confirmLayer, modalLayer, useHistoryListen, formatTimeByToday, toast } from '@utils'
import { getParams, classNames, useThrottle } from '@dt/fe-utils'
import { ProductStyleController, CashierController, RestoreOrderController, ScrollController, DeliveryController, DiningNumberPickController, MallChangeController } from '@ctrls/index'
import { thirdConfigG } from 'controllers/third'
import { Advert as MenuAdvert, Icon, ConfirmModal, SelectAddressModal } from '@cps'
import { MenuStyleDefault, CartBar, ProductRecommendBar, CartSupportBar, FullOffBar, MenuStyleWaterfall } from './components'
import PreOrderingController from '@ctrls/preOrderingController'
import pauseOrderImg from '@img/pauseOrder.png'
import './index.scss'

export const prodRecommendContent = createContext(null)

// interface
interface IProps extends IPage {
}

let saveStoreId = 0
let showAdvertTimeout = null

const Menu: FC<IProps> = ({ pageName }) => {
  const history = useHistoryNew()
  const { addMyAppTime = 0, inMiniApp = 0, tt: targetType = '', et = '', source = '' } = getParams()
  const isBuyTogether = !!Config.buyTogetherId || targetType === 'buyTogether'
  const isAdvertMenu = targetType === 'advert'
  const { info: store } = storeMobx
  const { mealDecorates, globalDecorates } = decorationMobx
  const { discountResult } = discountMobx
  const { mealsWaitingTime = {}, storeExtInfo = {} } = store
  const [showWaiting, setShowWaiting] = useState(true)
  // 弹窗流程是否结束
  const [modalFinish, setModalFinish] = useState(false)
  const [modalFlag, setModalFlag] = useState(0)
  const isCanPopUpsModalShowRef = useRef<number>(0)
  const [isAddMyAppModalShow, setAddMyAppModalShow] = useState<boolean>(false)
  const [recommendShakeProduct, setRecommendShakeProduct] = useState(null)
  const [recommendBubbleProduct, setRecommendBubbleProduct] = useState(null)
  const isStoreStatusModalCanShowRef = useRef(null)
  const isCanMobileBookingOrder = useMemo(() => {
    return !!(timePickMobx.canBookingTime && timePickMobx.canPick)
  }, [timePickMobx.canBookingTime])

  // 判断当前是否可支持就餐方式
  const isCanOrderByEatType = useCallback((_eatType?: any) => {
    const eatType = _eatType || cartMobx.info.eatType
    if (Config.codeType === 'brand') {
      return !eatTypeStatusMobx.isEatTypeEnable(eatType) && isCanMobileBookingOrder || eatTypeStatusMobx.isEatTypeEnable(eatType)
    }

    return eatTypeStatusMobx.isEatTypeEnable(eatType)
  }, [cartMobx.info.eatType, isCanMobileBookingOrder])

  // 处理首页滚动
  const handleHomeOnScroll = useThrottle(function (e: any) {
    const scrollTop = typeof e === 'number' ? e : (e.detail?.scrollTop || 0)
    const startY = typeof e === 'number' ? e : (e.detail?.startY || 0)
    if (Math.abs(scrollTop - startY) > 200) {
      handleLensterUseNotDoRecommend(e)
    }
    if (scrollTop < 0) {
      return false
    }
    ScrollController.handScroll(scrollTop, '#allMenuWarp')
  }, 100)

  // 监听页面操作，如果3s用户未操作，给予用户只能推荐菜品
  const handleLensterUseNotDoRecommend = (e?: any) => {
    ProductStyleController.setStartRecommendProduct(e, (product = null, recommendType = 'shake') => {
      if (recommendType === 'shake') {
        setRecommendShakeProduct(product)
      } else {
        setRecommendBubbleProduct(product)
      }
    })
  }

  // 添加到我的小程序
  const handleAddMyAppModalClose = () => {
    setAddMyAppModalShow(false)
    let addTime = Number(addMyAppTime) + 1
    thirdConfigG()?.postMessage({
      type: 'addMyAppTime',
      addTime
    })
  }

  const saveGlobalData = () => {
    saveStoreId = storeMobx.info.storeId
  }

  /**
   * 弹窗控制
   */

  // 门店状态判断
  const handleStoreStatus = () => {
    console.log('弹窗层级:', 1)
    if (storeMobx.viewStoreList.length) {
      // 没有门店
      if (restaurantConfig.storeId && !storeMobx.info.storeName) {
        history.replace('/noStore')
        // const hasLbs = restaurantCenter.config.cityName || restaurantCenter.config?.lbs?.lat && restaurantCenter.config?.lbs?.lng
        // if (hasLbs) {
        //   history.replace('/store')
        // } else {
        //   history.replace('/noStore')
        // }
        return
      }
      // 没有门店开通外卖
      if ((et || cartMobx.info.eatType) === 'delivery' && !storeMobx.hasDeliveryStore) {
        history.replace('/noStoreStatus/delivery')
        return
      }
      // // 没有门店开通外卖
      // if ((et || cartMobx.info.eatType) === 'delivery' && !storeMobx.info.openSelfDelivery) {
      //   history.replace('/noStoreStatus/selfDelivery')
      //   return
      // }
      // // 没有门店开通自提
      // if ((et || cartMobx.info.eatType) === 'pickup' && !storeMobx.info.openPickup) {
      //   history.replace('/noStoreStatus/pickup')
      //   return
      // }
      // // 没有门店开通堂食
      // if ((et || cartMobx.info.eatType) === 'dinein' && !storeMobx.info.openDinein) {
      //   history.replace('/noStoreStatus/brandDinein')
      //   return
      // }
      if (cartMobx.info.eatType === TEEatType.delivery && isCanOrderByEatType('delivery')) {
        if (!deliveryMobx.hasAddresses) memberMobx.getMemberAddress()
      }
      // 门店暂时关闭线上点餐
      if (storeMobx.info?.storeId && storeMobx.info.inSale && cartMobx.info.eatType) {
        // pos关闭点单
        if (storeMobx.info?.pauseMobileOrderTime?.all) {
          if (Config.codeType === 'brand') {
            showOrderPauseModal()
            return
          } else {
            history.replace('/noStoreStatus/ordering')
            return
          }
        } else {
          const eatTypes = eatTypeStatusMobx.enableEatTypeList as any
          storeMobx.setOpenBrandEatTypes(eatTypes)
          if (!eatTypes.length) {
            showOrderPauseModal()
            return
          }

          if (!eatTypeStatusMobx.checkBrandEatTypeInStore(cartMobx.info.eatType, true)) {
            const eatTypeStr = i18n.t(`menu.${cartMobx.info.eatType}`)
            const tip = i18n.t('store.pauseEatType', { eatType: eatTypeStr })
            showOrderPauseModal(tip)
            return
          }
        }
        showAdvert()
      }
    } else {
      history.replace('/noStore')
      // const hasLbs = restaurantCenter.config.cityName || restaurantCenter.config?.lbs?.lat && restaurantCenter.config?.lbs?.lng
      // if (hasLbs) {
      //   history.replace('/store')
      // } else {
      //   history.replace('/noStore')
      // }
    }
  }

  // 堂食就餐人数弹层
  const showDiningModal = async () => {
    console.log('弹窗层级:', 4)
    setModalFlag(4)
    const isCanDinein = storeMobx.info.storeId && storeMobx.info.diningNumberConfig?.status === 1 && cartMobx.info.eatType === 'dinein' && isCanOrderByEatType('dinein') && !cartMobx.info.person && !Config.queueId
    if (isCanDinein) {
      saveGlobalData()
      await DiningNumberPickController.showPicker()
    }
    setModalFinish(true)
  }

  // 预订单购物车加入堂食购物车
  const showPreOrderModal = () => {
    console.log('弹窗层级:', 5)
    setModalFlag(5)
    const isCanPreOrder = storeMobx.info.storeId && Config.codeType === 'table' && isCanOrderByEatType(cartMobx.info.eatType) && !Config.queueId
    isCanPreOrder && PreOrderingController.checkHasCartItemsInCart()
  }

  // 外卖新建地址弹层
  const showEditAddress = async () => {
    console.log('弹窗层级:', 4.1)
    if (deliveryMobx.isShowModal || isBuyTogether) return
    if (!deliveryMobx.hasAddresses) await memberMobx.getMemberAddress()
    // 需要增加未选择地址，进入外卖菜单，弹出地址选择
    if (!restaurantConfig.lbsAddress && deliveryMobx.hasAddresses && !deliveryMobx.address) {
      modalLayer(SelectAddressModal, {
        eatType: TEEatType.delivery
      }, 'SelectAddressModal').then(() => {
      }, () => { })
      if (!deliveryMobx.availableAddress) {
        toast({
          message: `${i18n.t('location.noStoreInAddress')},<br/>${i18n.t('location.noStoreInAddress2')}`,
          time: 2000,
          position: 'middle',
          cssClass: 'toastW50'
        })
      }
    }
    /** 没有地址，新增地址 */
    if (!deliveryMobx.hasAddresses) {
      DeliveryController.editAddressModal({
        eatType: TEEatType.delivery,
        callback: (store) => {
          if (store) {
            confirmLayer({
              title: i18n.t('common.attention'),
              children: (
                <>
                  <div className='near-tip'>{i18n.t('newCart.matchNearStore')}</div>
                  <div className='near-store'>
                    <Icon name='dinein3' />{store?.storeName}
                  </div>
                </>
              ),
              className: 'near-store-confirm-modal',
              isLight: true,
              canClose: true,
            }).then(() => {
              storeMobx.initInfo(store)
            }, () => { })
          }
        }
      })
    }
  }

  // 门店暂停接单弹窗控制
  const showOrderPauseModal = (tip?: string) => {
    if (isBuyTogether) return
    let isStoreStatusModalCanShow = isStoreStatusModalCanShowRef.current
    if (!isStoreStatusModalCanShow) {
      return
    }
    const { enableEatTypeList } = eatTypeStatusMobx
    const noEnableBtnStr = isCanMobileBookingOrder ? i18n.t('menu.bookingOrder') : i18n.t('menu.seeMenu')
    const str = enableEatTypeList.length && !isCanMobileBookingOrder ? i18n.t('menu.toOrderByEatType', { eatType: i18n.t(`menu.${enableEatTypeList[0]}`) }) : noEnableBtnStr
    setTimeout(() => {
      modalLayer(ConfirmModal, {
        className: 'order-pause-confirm-modal',
        backdropDismiss: false,
        children: (
          <>
            <div className='modal-content'>
              <img src={pauseOrderImg} className='pause-img' />
              <div className='pause-tips'>
                <div className='pause-tip1'>{tip || i18n.t('store.pauseOrdering1')}</div>
                {!!timePickMobx.pauseOrderTime?.endTime && <div className='pause-tip2'>{i18n.t('store.openOrdering1', { time: formatTimeByToday(timePickMobx.pauseOrderTime?.endTime) })}</div>}
              </div>
            </div>
            <div className='modal-operate'>
              <div className='btn btn-primary' onClick={showOrderPauseModalOkBtnClick}>{str}</div>
              {
                Config.codeType === 'brand' && !!storeMobx.viewStoreList.filter(store => storeMobx.info?.storeId !== store.storeId).length && (
                  <div
                    className='btn btn-link btn-to-store'
                    onClick={() => {
                      history.replace('/store')
                    }}
                  >
                    {i18n.t('store.toOtherStore')}
                  </div>
                )
              }
            </div>
          </>
        ),
        hasFooter: false
      }, 'order-pause')
      // setIsStoreStatusModalCanShow(false)
      isStoreStatusModalCanShowRef.current = false
    }, 100)
  }

  // 门店暂停弹窗确认控制
  const showOrderPauseModalOkBtnClick = () => {
    const { enableEatTypeList } = eatTypeStatusMobx

    if (enableEatTypeList.length && !isCanMobileBookingOrder) {
      const eatType = enableEatTypeList[0]
      cartMobx.setEatType(eatType)
      modalLayer.close('order-pause')
      return
    }

    if (isCanMobileBookingOrder) {
      console.log('预约')
    } else {
      console.log('浏览菜单')
    }

    modalLayer.close('order-pause')
    showAdvert()
  }
  // 其他弹窗控制
  const showOtherModal = () => {
    console.log('弹窗层级:', 3)
    setModalFlag(3)
    if (cartMobx.info.eatType === 'delivery') {
      const isCanDelivery = isCanOrderByEatType('delivery')
      if (isCanDelivery) {
        console.log(deliveryMobx.availableAddress)
        showEditAddress()
      }
    } else {
      showDiningModal()
    }
  }
  // 弹窗广告控制
  const showPopUpsAdvert = async () => {
    if (isBuyTogether) return
    let value = await modalLayer(MenuAdvert, {
      type: 'popUps',
      showPage: 'meals'
    }, 'popUpsModal', true).then(res => {
      return res
    }).catch((err) => {
      return err
    })
    isCanPopUpsModalShowRef.current = storeMobx.info.storeId
    if (value?.target?.className?.indexOf('icon-close') > -1) {
      showOtherModal()
    }
    // showDiningModal()
  }
  // 广告
  const showAdvert = async () => {
    console.log('弹窗层级:', 2)
    if (source === 'checkout' || isAdvertMenu || isBuyTogether) {
      showOtherModal()
      return
    }
    if (orderMobx.viewDetailList.length || !restaurantConfig.storeId || storeMobx.info.status !== 'inSale') {
      showOtherModal()
      return
    }
    clearTimeout(showAdvertTimeout)
    await memberMobx.getUnacquiredCoupons()
    showAdvertTimeout = setTimeout(() => {
      if (advertMobx?.availableAdsGetStoreMap?.popUps?.meals?.length) {
        if (isCanPopUpsModalShowRef.current !== storeMobx.info.storeId) {
          showPopUpsAdvert()
          return
        }
      }
      showOtherModal()
    }, 2000)
  }

  // 是否跳转到购物车页
  const handleCart = () => {
    if (source === 'checkout') {
      if (et) CashierController.switchEatType(et)
      getParams()?.cn && productMobx.setChannel(getParams()?.cn)
      history.push('/checkout')
    }
  }

  /** 是否需要前往广告页 */

  useEffect(() => {
    let timer = null
    if (showWaiting) {
      timer = setTimeout(() => {
        setShowWaiting(false)
      }, 15000)
    } else {
      clearTimeout(timer)
      timer = null
    }
    return () => {
      timer && clearTimeout(timer)
    }
  }, [showWaiting])

  useEffect(() => {
    preOrderingMobx.initTablePreOrder()
    handleCart()
    isStoreStatusModalCanShowRef.current = true
    return () => {
      isStoreStatusModalCanShowRef.current = false
    }
  }, [])
  // useEffect
  useEffect(() => {
    if (!['/menu'].includes(history.location.pathname)) return
    isStoreStatusModalCanShowRef.current = true
    handleStoreStatus()
  }, [cartMobx.info.eatType])

  useEffect(() => {
    if (modalFinish && multiPersonOrderingMobx.multiPersonData.cartItem) {
      showPreOrderModal()
    }
  }, [modalFinish, multiPersonOrderingMobx.multiPersonData.cartItem])

  useIonViewDidEnter(() => {
    const { tt: targetType = '' } = getParams()
    // 扫桌码进入，如果没有登录跳转登录页
    if (Config.codeType === 'table' && !multiPersonMobx.getCurrentPersonInfo()?.personId) {
      restaurantCenter.init()
      // history.push('/visit')
      // multiPersonMobx.generateCharacter()
      // 是从visit返回的则肯定是桌台模式，并且已经选中了门店
    } else if (history.getPrevState() === '/visit') {
      RestoreOrderController.restore()
    } else {
      CashierController.initInPageForNoStore(targetType)
    }
    MallChangeController.menuSwitchEatType()
    // 未录桌订单
    if (!isBuyTogether) {
      RestoreOrderController.orderEnterTable()
    }
    ScrollController.reset()

    if (saveStoreId !== storeMobx.info.storeId) {
      handleStoreStatus()
    }
    if (globalDecorates.isOpenMiniAppAdd && Number(inMiniApp) && !Number(addMyAppTime)) {
      setAddMyAppModalShow(true)
    }
    advertMobx.checkToMenuAdvert()
  })

  useHistoryListen((pathname) => {
    if (['/store'].includes(pathname)) {
      BASECONFIG.openEnterStore = 0
      return
    }
    if (['/menu'].includes(pathname)) {
      return
    }
    isStoreStatusModalCanShowRef.current = false
  })

  return (
    <IonPage className='menu' title={pageName}>
      <>
        <IonContent
          className='menu-container'
          scrollEvents
          onIonScrollStart={() => (ScrollController.isScrolling = true)}
          onIonScrollEnd={(e) => {
            ScrollController.isScrolling = false
            const menuMeasureHeightDom = document.querySelector('.menu-measure-height') as HTMLElement
            if (menuMeasureHeightDom) {
              const clientRects = menuMeasureHeightDom.getClientRects()
              if (clientRects && clientRects.length) {
                handleHomeOnScroll(Math.abs(clientRects[0].top))
              }
            }
          }}
          onIonScroll={(e) => { handleHomeOnScroll(e) }}
        >
          <div className={`menu-measure-height ${!decorationMobx.tabBarVisible ? ' no-tabbar' : ''}`} id='allMenuWarp'>
            <prodRecommendContent.Provider value={{ recommendShakeProduct, setRecommendShakeProduct }}>
              {restaurantConfig.displayMode === 'waterfallCategory' ? <MenuStyleWaterfall /> : <MenuStyleDefault />}
            </prodRecommendContent.Provider>
          </div>
        </IonContent>
        <div className={classNames('cart-box', { deep: isBuyTogether, notabbar: !decorationMobx.tabBarVisible, hasfullof: !!discountResult?.designatedBuyAgain, hasSafe: themeMobx?.data?.tabBar?.enablePosition === 1 })}>
          {
            !isBuyTogether && <CartSupportBar />
          }
          <CartBar onClick={() => {
            if (isBuyTogether) {
              history.push('/buyTogetherCart')
            } else {
              history.push('/checkout')
            }
          }}
          />
        </div>
        <ProductRecommendBar data={{ recommendBubbleProduct, setRecommendBubbleProduct }} />
        {!!discountResult?.designatedBuyAgain && <FullOffBar />}
        {/* {
          restaurantConfig.displayMode === 'waterfall' && <SearchButton onClick={() => CashierController.showCategoryModal()} />
        } */}
        {
          isAddMyAppModalShow && (
            <div className='add-app-box'>
              <div className='add-box-txt'>{i18n.t('decoration.addMyMimiApp1')}<svg width='26px' height='27px' viewBox='0 0 26 27' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink'><g id='画板' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'><path d='M6,16 C7.1045695,16 8,15.1045695 8,14 C8,12.8954305 7.1045695,12 6,12 C4.8954305,12 4,12.8954305 4,14 C4,15.1045695 4.8954305,16 6,16 Z M21,16 C22.1045695,16 23,15.1045695 23,14 C23,12.8954305 22.1045695,12 21,12 C19.8954305,12 19,12.8954305 19,14 C19,15.1045695 19.8954305,16 21,16 Z M14,17 C15.6568542,17 17,15.6568542 17,14 C17,12.3431458 15.6568542,11 14,11 C12.3431458,11 11,12.3431458 11,14 C11,15.6568542 12.3431458,17 14,17 Z' id='形状结合' fill='#161616'></path></g></svg>{i18n.t('decoration.addMyMimiApp2')}</div>
              <i className='iconfont icon-close' onClick={handleAddMyAppModalClose} />
            </div>
          )
        }
      </>
    </IonPage>
  )
}

export default observer(Menu)
